interface Props {
  size?: "medium" | "large"
}

export const VerticalSpace = ({ size = "medium" }: Props) =>
  <div style={{ height: size === "medium" ? 10 : 20 }} />